import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import userReducer from "./user";
import boxReducer from "./box";
import customerReducer from "./customer";
import kitReducer from "./kit";
import connectionReducer from "./connection";
import highstateReducer from "./highstate";
import menuReducer from "./menu";
import validationReducer from "./validation";
import remediationReducer from "./remediation";
import designerReducer from "./designer";
import edmiReducer from "./edmi";

export default combineReducers({
  routing: routerReducer,
  user: userReducer,
  box: boxReducer,
  customer: customerReducer,
  kit: kitReducer,
  connection: connectionReducer,
  highstate: highstateReducer,
  menu: menuReducer,
  validation: validationReducer,
  remediation: remediationReducer,
  designer: designerReducer,
  edmi: edmiReducer,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js